import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    BadgeCount: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'BadgeCount' };

import { computed } from 'vue';

/**
 * ...
 */
export interface Props {
  value: number;
}

/** ... */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: number;
};



/** ... */
const count = computed(() => Math.max(0, props.value));
/** ... */
const displayCount = computed(() =>
  count.value >= 100 ? '99+' : count.value.toString(),
);

return { __sfc: true,props, count, displayCount }
}

})